// @ts-nocheck
import React, { memo, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { OutputSuggest } from "../output_suggests/OutputSuggest";
import TagInputField from "../../common/Outputs/TagInputField";
import { useTranslation } from "react-i18next";
import useLanguageChange from "../../../hooks/useLanguageChange";

export const OperationTitleInput = memo(
  ({ default_value, outputs, workflow_booted_at, model, code, class_name = null, locale, testId = "" }) => {
    const { t } = useLanguageChange(locale);
    const [inputDefined, setInputDefined] = useState();
    /** @type {React.RefObject.<HTMLElement>} */
    const inputRef = useRef(null);

    return (
      <div className="field sm test-operation-title-input">
        <div className="form-group">
          <label>{t("OperationTitleInput.タイトル")}</label>
          {inputDefined && (
            <OutputSuggest
              outputs={outputs}
              workflow_booted_at={workflow_booted_at}
              target={inputRef.current.target}
              setOutputs={(value) => {
                inputRef.current?.handleInsertTag(value);
              }}
            />
          )}
          <TagInputField
            ref={inputRef}
            initialContent={default_value}
            handleFocus={() => setInputDefined(true)}
            outputs={outputs}
            name={`${model}[title]`}
            id={`${model}_title`}
            testId={testId}
          />
        </div>
      </div>
    );
  },
);

OperationTitleInput.propTypes = {
  default_value: PropTypes.string,
  outputs: PropTypes.arrayOf(PropTypes.object),
  workflow_booted_at: PropTypes.string,
  model: PropTypes.string,
  class_name: PropTypes.string,
  code: PropTypes.string,
  locale: PropTypes.string,
  testId: PropTypes.string,
};
